import { render, staticRenderFns } from "./pay_tan_editdetail.vue?vue&type=template&id=3bc27bb2&scoped=true"
import script from "./pay_tan_editdetail.vue?vue&type=script&lang=js"
export * from "./pay_tan_editdetail.vue?vue&type=script&lang=js"
import style0 from "./pay_tan_editdetail.vue?vue&type=style&index=0&id=3bc27bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc27bb2",
  null
  
)

export default component.exports